import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { OrganizationBillingFacade } from '../../../../../Facades/Organizations/organization-billing.facade';
import { DATE_TIME_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import {
  SUBSCRIPTION_CONTROL_LINK_LABEL,
} from '../../../../../Consts/billing.const';
import {
  PRICE_COMPONENT_LABEL,
  PRICE_COMPONENT_PRODUCT_NAME,
} from '../../../../../Enums/price-component-type.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-organization-subscription',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    DecimalPipe,
    MatIconModule,
    MatTooltipModule,
    AvEmptyStateComponent,
    AvStatusChipComponent,
    TranslateModule,
  ],
  templateUrl: './organization-subscription.component.html',
  styleUrl: './organization-subscription.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class OrganizationSubscriptionComponent {
  readonly facade = inject(OrganizationBillingFacade);

  readonly organizationId = input<string>('');

  readonly dateTimeFormat = DATE_TIME_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;
  readonly controlLinkLabel = SUBSCRIPTION_CONTROL_LINK_LABEL;
  readonly componentLabelKeys = PRICE_COMPONENT_LABEL;
  readonly productNames = PRICE_COMPONENT_PRODUCT_NAME;

  readonly hasSubscription = computed<boolean>(() => this.facade.subscription() !== null);

  componentLabelKey(componentType: string): string {
    return this.componentLabelKeys[componentType as keyof typeof this.componentLabelKeys] ?? componentType;
  }

  productName(componentType: string): string {
    return this.productNames[componentType as keyof typeof this.productNames] ?? componentType;
  }

  isMismatched(quantity: number, licenceCount: number): boolean {
    return quantity !== licenceCount;
  }
}
